module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd_fixed"
  }, [_c('div', {
    staticClass: "hd"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("G客中心")])]), _vm._v(" "), _c('svg', {
    staticClass: "actionBg",
    attrs: {
      "width": "100vw",
      "height": "27.73vw",
      "viewBox": "0 0 375 104",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("形状结合@3x")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "页面-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "G客中心",
      "transform": "translate(0.000000, -51.000000)",
      "fill": "#2C2C2C"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0,51 L375,51 L375,138 L372.172635,138.511249 C310.911081,149.50375 249.520202,155 188,155 C125.533333,155 62.8666666,149.333333 0,138 L0,138 L0,51 Z",
      "id": "形状结合"
    }
  })])])]), _vm._v(" "), (_vm.displayChosenResearchGroup) ? _c('van-swipe', {
    on: {
      "change": _vm.changeVip
    }
  }, _vm._l((5), function(item) {
    return _c('van-swipe-item', {
      key: item
    }, [_c('div', {
      staticClass: "current_group"
    }, [_vm._v(_vm._s(_vm.displayChosenResearchGroup.researchGroupName))]), _vm._v(" "), (item === _vm.displayChosenResearchGroup.vipLevel) ? _c('svg', {
      staticClass: "current_status",
      attrs: {
        "width": "71px",
        "height": "18px",
        "viewBox": "0 0 71 18",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_c('title', [_vm._v("课题组组长标签")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs', [_c('linearGradient', {
      attrs: {
        "x1": "100%",
        "y1": "50%",
        "x2": "0%",
        "y2": "50%",
        "id": "linearGradient-1"
      }
    }, [_c('stop', {
      attrs: {
        "stop-color": "#F0CFA6",
        "offset": "0%"
      }
    }), _vm._v(" "), _c('stop', {
      attrs: {
        "stop-color": "#C1864A",
        "offset": "100%"
      }
    })], 1)], 1), _vm._v(" "), _c('g', {
      attrs: {
        "id": "页面-1",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('g', {
      attrs: {
        "id": "G客中心",
        "transform": "translate(-254.000000, -104.000000)"
      }
    }, [_c('g', {
      attrs: {
        "id": "编组",
        "transform": "translate(25.000000, 61.000000)"
      }
    }, [_c('g', {
      attrs: {
        "id": "课题组组长标签",
        "transform": "translate(229.000000, 43.000000)"
      }
    }, [_c('rect', {
      attrs: {
        "id": "矩形",
        "fill": "url(#linearGradient-1)",
        "x": "0",
        "y": "0",
        "width": "71",
        "height": "18",
        "rx": "9"
      }
    }), _vm._v(" "), _c('text', {
      attrs: {
        "id": "当前等级",
        "font-family": "PingFangSC-Regular, PingFang SC",
        "font-size": "12",
        "font-weight": "normal",
        "fill": "#FFFFFF"
      }
    }, [_c('tspan', {
      attrs: {
        "x": "11",
        "y": "13"
      }
    }, [_vm._v("当前等级")])])])])])])]) : _vm._e(), _vm._v(" "), _c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": _vm.vipImg(item)
      }
    })])
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box_2"
  }, [_c('object', {
    staticClass: "benefit_svg",
    attrs: {
      "data": _vm.vipBenefitSvg,
      "type": "image/svg+xml"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-138e8f6f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/User/MyResearchGroup/researchGroupBenefit/Benefit.vue
// module id = 1542
// module chunks = 8